import { KnmCollapse } from '../../KnmPackage/MainModule/components/KnmCollapse';
import { IGroupStatusConditionsForm } from '../PassportGroupFormModule/interfaces/IGroupStatusConditionsForm';
import { FieldBlock } from '../../UIPackage/FormModule/components/FieldBlock';
import { SelectInput } from '../../UIPackage/MainModule/components/SelectInput';
import { PassportGroupPassportTypeEnum } from '../PassportGroupFormModule/enums/PassportGroupPassportTypeEnum';

interface IPassportGroupDetailStatusConditionsProps {
  condition: IGroupStatusConditionsForm | undefined;
  category: PassportGroupPassportTypeEnum | undefined;
}

export const PassportGroupDetailStatusConditions = ({
  condition,
  category,
}: IPassportGroupDetailStatusConditionsProps) => {
  const isErp = category === PassportGroupPassportTypeEnum.ERP;

  if (!condition || !Object.values(condition).find(item => !!item)) {
    return null;
  }

  return (
    <KnmCollapse title="Статусы мероприятия">
      <>
        {!!condition.statuses?.length && (
          <FieldBlock label={isErp ? 'Статус проверки' : 'Статус мероприятия'} margin="bottom">
            <SelectInput value={condition.statuses} isMulti disabled />
          </FieldBlock>
        )}
        {!!condition.publishedStatus && (
          <FieldBlock label={isErp ? 'Статус публикации проверки' : 'Статус публикации мероприятия'} margin="bottom">
            <SelectInput value={condition.publishedStatus} disabled />
          </FieldBlock>
        )}
      </>
    </KnmCollapse>
  );
};
